import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject } from "rxjs";


export interface DialogData {
  title: string;
  body: string;
  okBtnName: string;
  closeBtnName: string;
}

@Component({
  selector: 'app-modal-content',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['./confirm-box.component.scss']
})
export class ConfirmBoxComponent implements OnInit {

  body!: string;
  title!: string;
  okBtnName!: string
  closeBtnName!: string | undefined;

  // public onClose!: Subject<boolean>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.body = data.body;
    this.title = data.title;
    this.okBtnName = data.okBtnName;
    this.closeBtnName = data.closeBtnName;
   }

  public ngOnInit(): void {
    // this.onClose = new Subject();
  }

  // public onConfirm(): void {
  //   this.onClose.next(true);
  //   this.bsModalRef.hide();
  // }

  // public onCancel(): void {
  //   this.onClose.next(false);
  //   this.bsModalRef.hide();
  // }
}